import ReactDOM from 'react-dom/client';
import App from './App';
import './global.css';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import materialTheme from './material-theme';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { basicLogger } from 'launchdarkly-js-client-sdk';

const initializeNewRelic = () => import('./utils/new-relic');

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.VITE_LAUNCHDARKLY_CLIENT_KEY as string,
    context: {
      kind: 'user',
      ...{ anonymous: true },
    },
    options: {
      logger: basicLogger({
        level: process.env.NODE_ENV === 'development' ? 'debug' : 'info',
      }),
      sendEventsOnlyForVariation: true,
      useReport: true,
    },
    reactOptions: {
      sendEventsOnFlagRead: true,
      useCamelCaseFlagKeys: false,
    },
  });

  if (process.env.VITE_MODE !== 'development') {
    void initializeNewRelic();
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={materialTheme}>
        <LDProvider>
          <App />
        </LDProvider>
      </ThemeProvider>
    </StyledEngineProvider>,
  );
})();
